import Vue from 'vue'
import router from '../../router'

export default {
  saveInvestorPage ({ commit, dispatch }, investorPage) {
    let method = investorPage.id === 'new' ? 'post' : 'put'

    return Vue.axios[method]('investor-page', { investorPage })
      .then(({ data }) => {
        investorPage.id = data.id
        investorPage.promo_id = investorPage.promo_id ? investorPage.promo_id : null

        commit('UPDATE_INVESTOR_PAGE_ITEM', investorPage)

        if (investorPage.newPhoto) {
          dispatch(
            'loadInvestorPagePhoto',
            { formData: investorPage.newPhoto, id: investorPage.id }
          )
        }

        if (investorPage.newAboutPreview) {
          dispatch(
            'loadInvestorPageAboutPreview',
            { formData: investorPage.newAboutPreview, id: investorPage.id }
          )
        }

        if (method === 'post') {
          router.push({ name: 'Investor', params: { id: investorPage.id } })
        }
      })
  },

  loadInvestorPagePhoto ({ commit }, {formData, id}) {
    return Vue.axios.post(`investor-page/${id}/change-photo`, formData)
      .then(({ data }) => commit('LOAD_INVESTOR_PHOTO', data))
  },

  loadInvestorPageAboutPreview ({ commit }, { formData, id }) {
    return Vue.axios.post(`investor-page/${id}/change-about-preview`, formData)
      .then(({ data }) => commit('LOAD_INVESTOR_ABOUT_PREVIEW', data))
  },

  getInvestorPages ({ commit, dispatch }, id) {
    return Vue.axios.get('investor-page')
      .then(({ data }) => {
        commit('UPDATE_INVESTOR_PAGES', data)
        if (data[0] && !id) {
          dispatch('getInvestorPage', data[0].id)
        }
      })
  },

  getInvestorPage ({ commit }, id) {
    return Vue.axios.get(`investor-page/${id}`)
      .then(({ data }) => { commit('ADD_INVESTOR_PAGE', data) })
  },

  deleteInvestorPage ({ state, commit }) {
    return Vue.axios.delete(`investor-page/${state.investorPage.id}`)
      .then(({ data }) => {
        commit('DELETE_INVESTOR_PAGE', state.investorPage.id)
        if (state.investorPages && state.investorPages[0]) {
          commit('ADD_INVESTOR_PAGE', state.investorPages[0])
          router.push(`loans/investor/${state.investorPage.id}`)
        }
      })
  },

  addInvestorPage ({ commit }) {
    commit('ADD_NEW_INVESTOR_PAGE')
  },

  updateInvestorPage ({ commit }, page) {
    commit('UPDATE_INVESTOR_PAGE_ITEM', page)
  },

  // advantages
  addInvestorPageAdvantage ({ commit }, data) {
    commit('INVESTOR_PAGE_ADD_ADVANTAGE', data)
  },
  deleteInvestorPageAdvantage ({ commit }, id) {
    commit('INVESTOR_PAGE_DELETE_ADVANTAGE', id)
  },
  updateInvestorPageAdvantage ({ commit }, data) {
    commit('INVESTOR_PAGE_UPDATE_ADVANTAGE', data)
  },

  // potential users
  addInvestorPagePotentialUser ({ commit }, data) {
    commit('INVESTOR_PAGE_ADD_POTENTIAL_USER', data)
  },
  deleteInvestorPagePotentialUser ({ commit }, id) {
    commit('INVESTOR_PAGE_DELETE_POTENTIAL_USER', id)
  },
  updateInvestorPagePotentialUser ({ commit }, data) {
    commit('INVESTOR_PAGE_UPDATE_POTENTIAL_USER', data)
  },

  // reasons
  addInvestorPageReason ({ commit }, data) {
    commit('INVESTOR_PAGE_ADD_REASON', data)
  },
  deleteInvestorPageReason ({ commit }, id) {
    commit('INVESTOR_PAGE_DELETE_REASON', id)
  },
  updateInvestorPageReason ({ commit }, data) {
    commit('INVESTOR_PAGE_UPDATE_REASONS', data)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/investor.js